import { useParams } from "react-router-dom";
import ActivityCategorymasterInput from "../../ActivityMasterInput/ActivityCategorymasterInput";
import CustomHeaderTitle from "../../constants/CustomHeaderTitle";
import HeaderBread from "../../HeaderBread";
import Layout from "../../../Layout";
import { useEffect, useState } from "react";
import { getOneActivityCategory } from "../../../utils/ApiCalls/Mobile/ActivityMasters";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import Swal from "sweetalert2";
import MobilePagemasterInput from "./MobilePagemasterInput";
import ShipMobilePagemasterInput from "./ShipMobilePagemasterInput";

const AddMobilePageDataShip = ({ category }) => {
  const params = useParams();
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const [navigation, setNavigation] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    console.log("hii");
    getOptionLocation();
  }, []);
  useEffect(() => {
    console.log({ category });
    if (category?.id)
      setNavigation([
        {
          title: "Home",
          route: "/",
        },
        {
          title: "Mobile App Shore CMS",
          route: "/",
        },
        {
          title: "All Pages",
          route: "/ship/all-pages/genting-dream/" + category.id,
        },
        {
          title: vesselOptions.find((item) => item.id == category?.vessel_id)
            ?.name,
          route: "/ship/all-pages/" +
        vesselOptions
          .find((item) => item.id == category?.vessel_id)
          ?.name?.replaceAll(" ", "-")
          ?.toLowerCase() +
        "/" + + category.id,
        },
        {
          title: category?.name,
          route: "/ship/all-pages/" +
        vesselOptions
          .find((item) => item.id == category?.vessel_id)
          ?.name?.replaceAll(" ", "-")
          ?.toLowerCase() +
        "/" + + category.id,
        },
      ]);
  }, [vesselOptions, category]);

  return (
    <Layout type={"create_per"} module_data={"Categories"}>
      <CustomHeaderTitle title={"Create Categories"} />
      <HeaderBread
        navigation={navigation}
        title={"Create Ship " + category?.name + " Page"}
      ></HeaderBread>
      {category&&<ShipMobilePagemasterInput category={category} shore_page_id={params["page-id"]} crisisdata={{}} />}
    </Layout>
  );
};

export default AddMobilePageDataShip;
